<p>
  <!--jobseekers-shell works!-->
  <router-outlet></router-outlet>
</p>
